export const couponsData = [
  {
    key: "1",
    COUPONNAME: "Summer Sale 2024",
    CODE: "SUMMER2024",
    DESCRIPTION: "20% off on all rentals in July",
    DISCOUNTTYPE: "Percentage",
    DISCOUNT: "20%",
    LIMIT: "10",
    VALID: "24 Jan 2025",
    STATUS: "Active",
  },
  {
    key: "2",
    COUPONNAME: "Fall Savings",
    CODE: "FALL15",
    DESCRIPTION: "15% off for long-term rentals",
    DISCOUNTTYPE: "Percentage",
    DISCOUNT: "15%",
    LIMIT: "3",
    VALID: "19 Dec 2024",
    STATUS: "Inactive",
  },
  {
    key: "3",
    COUPONNAME: "Weekend Discount",
    CODE: "WEEKEND10",
    DESCRIPTION: "10% off on weekend rentals",
    DISCOUNTTYPE: "Percentage",
    DISCOUNT: "10%",
    LIMIT: "8",
    VALID: "11 Dec 2024",
    STATUS: "Active",
  },
  {
    key: "4",
    COUPONNAME: "First Timer Special",
    CODE: "FIRSTTIME20",
    DESCRIPTION: "20% off for first-time customers",
    DISCOUNTTYPE: "Percentage",
    DISCOUNT: "20%",
    LIMIT: "14",
    VALID: "29 Nov 2024",
    STATUS: "Active",
  },
  {
    key: "5",
    COUPONNAME: "Holiday Cheer 2024",
    CODE: "HOLIDAY2024",
    DESCRIPTION: "25% off during the holiday season",
    DISCOUNTTYPE: "Percentage",
    DISCOUNT: "25%",
    LIMIT: "5",
    VALID: "03 Nov 2024",
    STATUS: "Active",
  },
  {
    key: "6",
    COUPONNAME: "VIP Discount",
    CODE: "VIPCUSTOMER25",
    DESCRIPTION: "Exclusive 25% discount for VIP users",
    DISCOUNTTYPE: "Percentage",
    DISCOUNT: "25%",
    LIMIT: "18",
    VALID: "31 Oct 2024",
    STATUS: "Inactive",
  },
  {
    key: "7",
    COUPONNAME: "SUV Special",
    CODE: "SUV50",
    DESCRIPTION: "$50 off on SUV rentals for 7+ days",
    DISCOUNTTYPE: "Fixed Amount",
    DISCOUNT: "$50",
    LIMIT: "4",
    VALID: "15 Oct 2024",
    STATUS: "Inactive",
  },
  {
    key: "8",
    COUPONNAME: "New Year 2025",
    CODE: "NEWYEAR2025",
    DESCRIPTION: "25% off for New Year bookings",
    DISCOUNTTYPE: "Percentage",
    DISCOUNT: "25%",
    LIMIT: "10",
    VALID: "26 Sep 2024",
    STATUS: "Active",
  },
  {
    key: "9",
    COUPONNAME: "Weekend Special",
    CODE: "WEEKEND50",
    DESCRIPTION: "Save $50 on weekend rentals.",
    DISCOUNTTYPE: "Fixed Amount",
    DISCOUNT: "$50",
    LIMIT: "9",
    VALID: "01 Sep 2024",
    STATUS: "Active",
  },
  {
    key: "10",
    COUPONNAME: "Refer a Friend",
    CODE: "REFERFRIEND10",
    DESCRIPTION: "Get $10 off for referring a friend",
    DISCOUNTTYPE: "Fixed Amount",
    DISCOUNT: "$10",
    LIMIT: "12",
    VALID: "15 Aug 2024",
    STATUS: "Active",
  },
];
